import { useEffect, useRef } from 'react';

const services = [
  {
    icon: 'ri-store-2-line',
    title: 'Pantallas para Expos y Ferias',
    description:
      'Pantallas LED de alta resolución para exposiciones comerciales, ferias industriales y stands corporativos. Máximo impacto para tu marca.',
    benefit: 'Destaca en cualquier expo',
    image:
      'https://readdy.ai/api/search-image?query=sleek%203x2%20meter%20LED%20display%20screen%20on%20modern%20trade%20show%20booth%20stand%2C%20modern%20exhibition%20hall%2C%20cyan%20blue%20neon%20accent%20lighting%2C%20professional%20corporate%20brand%20presentation%20setup%2C%20dark%20elegant%20venue%2C%20large%20format%203x2m%20LED%20screen%20for%20expo%20event%2C%20cinematic%20wide%20angle%20shot&width=600&height=400&seq=svc020&orientation=landscape',
  },
  {
    icon: 'ri-presentation-line',
    title: 'Pantallas para Conferencias',
    description:
      'Soluciones visuales profesionales para congresos, seminarios y presentaciones corporativas. Claridad y nitidez excepcionales.',
    benefit: 'Visibilidad perfecta',
    image:
      'https://readdy.ai/api/search-image?query=3x2%20meter%20LED%20display%20screen%20at%20corporate%20conference%20auditorium%2C%20professional%20presentation%20setup%20with%20large%20LED%20screen%2C%20dark%20elegant%20interior%2C%20cyan%20blue%20accent%20lighting%2C%20modern%20technology%20business%20event%2C%20premium%20audiovisual%20production%2C%20large%203x2m%20LED%20screen&width=600&height=400&seq=svc021&orientation=landscape',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Pantallas para Eventos Corporativos',
    description:
      'Galas, lanzamientos de producto, convenciones y reuniones de alto nivel. Tecnología visual que eleva la imagen de tu empresa.',
    benefit: 'Imagen corporativa premium',
    image:
      'https://readdy.ai/api/search-image?query=3x2%20meter%20LED%20display%20screen%20at%20luxury%20corporate%20gala%20product%20launch%20event%2C%20sleek%20large%20LED%20screen%2C%20dark%20elegant%20venue%2C%20cyan%20blue%20spotlight%20lighting%2C%20modern%20brand%20presentation%20stage%2C%20premium%20event%20production%2C%20cinematic%20photography&width=600&height=400&seq=svc022&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Instalación y Soporte Técnico',
    description:
      'Nuestro equipo especializado se encarga de todo: montaje, configuración, operación en vivo y desmontaje. Sin preocupaciones.',
    benefit: 'Soporte 24/7 en evento',
    
    image:
      'https://readdy.ai/api/search-image?query=professional%20AV%20technicians%20installing%203x2%20meter%20LED%20screen%20at%20expo%20trade%20show%20booth%2C%20dark%20industrial%20exhibition%20hall%2C%20cyan%20blue%20work%20lights%2C%20technical%20crew%20with%20large%20LED%20display%20equipment%2C%20premium%20event%20production%20setup%2C%20large%203x2m%20LED%20screen%20installation&width=600&height=400&seq=svc023&orientation=landscape',
  },
];

const ServicesSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.card-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="relative bg-[#111111] py-24 md:py-32">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-cyan-500/40 bg-cyan-500/10 text-cyan-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            Nuestros Servicios
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Soluciones visuales para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-sky-500">
              cada evento
            </span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
            Contamos con equipos de última generación y un equipo experto para hacer de tu expo o evento una experiencia visual única.
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-sky-500 rounded-full mx-auto mt-6" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="card-reveal group relative bg-[#1a1a1a] border border-cyan-500/15 rounded-2xl overflow-hidden hover:-translate-y-2 hover:border-cyan-500/50 hover:shadow-[0_20px_60px_rgba(6,182,212,0.12)] transition-all duration-400 cursor-pointer"
              style={{ opacity: 0, transform: 'translateY(40px)', transition: 'opacity 0.7s ease, transform 0.7s ease, box-shadow 0.3s ease, border-color 0.3s ease' }}
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />
                {/* Benefit badge */}
                <div className="absolute top-3 right-3 bg-cyan-500/20 border border-cyan-500/40 text-cyan-400 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                  {service.benefit}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500/20 to-sky-500/10 border border-cyan-500/30 mb-4">
                  <i className={`${service.icon} text-cyan-400 text-xl`} />
                </div>
                <h3 className="text-white font-semibold text-lg mb-3 leading-tight">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{service.description}</p>
              </div>

              {/* Bottom CTA */}
              <div className="px-6 pb-6">
                <button
                  onClick={() =>
                    window.open(
                      'https://wa.me/525525261379?text=Hola%2C%20me%20interesa%20cotizar%20' +
                        encodeURIComponent(service.title),
                      '_blank'
                    )
                  }
                  className="w-full flex items-center justify-center gap-2 border border-cyan-500/30 text-cyan-400 text-sm font-medium py-2.5 rounded-xl hover:bg-cyan-500/10 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line" />
                  Cotizar este servicio
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
